<label
  class="label"
  [for]="forId"
  ><span [innerHTML]="innerHTML"></span><ng-content></ng-content
></label>
